namespace Matrix {
    export function noCommaValidationRule(input, uniqueName) {
        input.addValidationRule(uniqueName, e => {
            if (input.value.match(/[,;:]/))
                return "This field shouldn't contain comma [ , ], semicolon [ ; ] and colon [ : ] !";
        });
    }
}